import ApiService from '@/core/services/api.service'
// action types
export const FETCH_VACCINE_REPORT = 'fetchVaccineReport'

// mutation types
export const SET_VACCINE_REPORT = 'setVaccineReport'
export const SET_ERROR = 'setError'

const state = {
  errors: null,
  doseOneDistrict: null,
  doseTwoDistrict: null,
  doseOneProvince: null,
  doseTwoProvince: null,
  doseThreeDistrict: null,
  doseThreeProvince: null,
  isReady: false,
}

const getters = {
  getDoseOneDistrict(state) {
    if (state.isReady) {
      return state.doseOneDistrict
    }
  },

  getDoseTwoDistrict(state) {
    if (state.isReady) {
      return state.doseTwoDistrict
    }
  },

  getDoseThreeDistrict(state) {
    if (state.isReady) {
      return state.doseThreeDistrict
    }
  },

  getDoseOneProvince(state) {
    if (state.isReady) {
      return state.doseOneProvince
    }
  },

  getDoseTwoProvince(state) {
    if (state.isReady) {
      return state.doseTwoProvince
    }
  },

  getDoseThreeProvince(state) {
    if (state.isReady) {
      return state.doseThreeProvince
    }
  },
}

const actions = {
  [FETCH_VACCINE_REPORT](context) {
    const fetchPosts = async (label) => {
      let params = {
        dose: label,
      }

      const data = ApiService.post(
        'cluster_immunization/vaccine_by_dose',
        params
      )
        .then(({ data }) => {
          // console.log('Here what post by dose returns', data.data)
          return data.data
        })
        .catch(({ response }) => {
          console.log(response.data.errors)
        })

      return data
    }

    const doses = [
      'doseOneDistrict',
      'doseTwoDistrict',
      'doseOneProvince',
      'doseTwoProvince',
      'doseThreeDistrict',
      'doseThreeProvince',
    ]
    doses.forEach(async (label) => {
      const data = await fetchPosts(label)
      // console.log(`Asynchronous ${data} is fetched for ${label}`)
      context.commit(SET_VACCINE_REPORT, { data, label })
    })
  },
}

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error
  },

  [SET_VACCINE_REPORT](state, payload) {
    state[payload.label] = Object.freeze(payload.data)
    if (
      state.doseOneDistrict &&
      state.doseTwoDistrict &&
      state.doseOneProvince &&
      state.doseTwoProvince
    ) {
      state.isReady = true
    }
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
